import React, { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import "./ContexteFiscal.css";

const Charges = (props) => {
  const { Outil } = props;
  const context = useContext(AppContext);

  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">📋</span>
          Charges déductibles
        </div>
        <div className="value-column">
          <span className="header-icon">💰</span>
          Montant
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* CSG déductibles sur revenus du patrimoine */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">💰</div>
            CSG déductibles sur revenus du patrimoine
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRCSGDedRevenuPatrimoine"]}
              onChange={context.handleInputChange(Outil + "IRCSGDedRevenuPatrimoine")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>

      {/* Section header: Pensions alimentaires versées à des enfants majeurs en vertu d'une décision de justice avant 2006 */}
      <div className="header-card" style={{ marginTop: "16px", background: "linear-gradient(135deg, #8BB9FF 0%, #6DA3FF 100%)" }}>
        <div className="category-column">
          <span className="header-icon">⚖️</span>
          Pensions alimentaires versées à des enfants majeurs en vertu d'une décision de justice avant 2006
        </div>
      </div>

      {/* 1er enfant - décision de justice avant 2006 */}
      <div className="card-list-container">
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👧</div>
            Premier enfant
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRPensionAlimEnfant1"]}
              onChange={context.handleInputChange(Outil + "IRPensionAlimEnfant1")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* 2ème enfant - décision de justice avant 2006 */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👧</div>
            Second enfant
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRPensionAlimEnfant2"]}
              onChange={context.handleInputChange(Outil + "IRPensionAlimEnfant2")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

      </div>

      {/* Section header: Autres pensions alimentaires versées à des enfants majeurs */}
      <div className="header-card" style={{ marginTop: "16px", background: "linear-gradient(135deg, #8BB9FF 0%, #6DA3FF 100%)" }}>
        <div className="category-column">
          <span className="header-icon">👨‍👩‍👧‍👦</span>
          Autres pensions alimentaires versées à des enfants majeurs
        </div>
      </div>

      {/* 1er enfant - autres pensions */}
      <div className="card-list-container">
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👧</div>
            Premier enfant
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRAutrePensionAlimEnfant1"]}
              onChange={context.handleInputChange(Outil + "IRAutrePensionAlimEnfant1")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* 2ème enfant - autres pensions */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👧</div>
            Second enfant
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRAutrePensionAlimEnfant2"]}
              onChange={context.handleInputChange(Outil + "IRAutrePensionAlimEnfant2")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

      </div>

      {/* Section header: Autres charges déductibles */}
      <div className="header-card" style={{ marginTop: "16px", background: "linear-gradient(135deg, #8BB9FF 0%, #6DA3FF 100%)" }}>
        <div className="category-column">
          <span className="header-icon">📋</span>
          Autres charges déductibles
        </div>
      </div>

      {/* Conteneur des cartes pour autres charges */}
      <div className="card-list-container">
        {/* Autres pensions alimentaires versées (décision de justice avant 2006) */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">⚖️</div>
            Autres pensions alimentaires versées (décision de justice avant 2006)
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRPensionAlim"]}
              onChange={context.handleInputChange(Outil + "IRPensionAlim")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Autres pensions alimentaires */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">👨‍👩‍👧‍👦</div>
            Autres pensions alimentaires
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRAutrePensionAlim"]}
              onChange={context.handleInputChange(Outil + "IRAutrePensionAlim")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Déductions fiscales diverses */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📊</div>
            Déductions fiscales diverses
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "DeductionFiscale"]}
              onChange={context.handleInputChange(Outil + "DeductionFiscale")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Charges;
